var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.2804,
    height: 30.2804,
    fill: "white",
    fillOpacity: 0.87
  })), "  -->\n", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 21.0286V25.2337H9.2519L21.6539 12.8317L17.4489 8.62663L5.04688 21.0286ZM24.9058 9.57977C25.3431 9.14245 25.3431 8.436 24.9058 7.99868L22.2819 5.37474C21.8445 4.93742 21.1381 4.93742 20.7008 5.37474L18.6487 7.4268L22.8537 11.6318L24.9058 9.57977V9.57977Z",
    fill: "#000C2B",
    fillOpacity: 0.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.904ce1b6f6eeaa81abc3438edc64fb17.svg";
export { ForwardRef as ReactComponent };